// wraps a Reflux.createStore in a class

import Reflux from "reflux";

export type Listenable<Args extends any[]> = {
    readonly listen: (callback: (...args: Args) => void) => () => void;
};

export type Subscription<T extends any[]> = {
    readonly stop: () => void;
    readonly listenable: Listenable<T>;
};

export class Store {
    _store: any;
    _subscriptions: Subscription<any>[];

    constructor() {
        this._store = Reflux.createStore();
        this._subscriptions = [];
    }

    listen(handler: (arg0: any) => void): () => void {
        return this._store.listen(handler);
    }

    listenTo<T extends any[]>(listenable: Listenable<T>, callback: (...args: T) => any): Subscription<T> {
        // listenTo binds to the store instance by default, but that's not very useful for us here, so bind to this
        const subscription = this._store.listenTo(listenable, (callback as any).bind(this));
        if (subscription) {
            this._subscriptions.push(subscription);
        }
        return subscription;
    }

    unhook() {
        for (const subscription of this._subscriptions) {
            subscription.stop();
        }
        this._subscriptions = [];
    }

    trigger(data?: any) {
        this._store.trigger(data);
    }
}
